var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.id)?_c('section',{attrs:{"id":"page"}},[_c('CCard',[_c('CCardBody',{domProps:{"innerHTML":_vm._s(_vm.page.body)}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }